import { CompanyMetadata } from '__generated__/GQL';
import { ApplicantType } from 'features/Onboarding/types';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getPricingPlanModuleStatus = ({
  applicantType,
  companyMetadata,
}: {
  companyMetadata: Pick<CompanyMetadata, 'selectedPlanId'>;
  applicantType: ApplicantType;
}) => {
  if (applicantType !== ApplicantType.AccountHolder) {
    return VerificationStatus.Irrelevant;
  }

  return companyMetadata.selectedPlanId
    ? VerificationStatus.Completed
    : VerificationStatus.ToDo;
};

export default getPricingPlanModuleStatus;
